module.exports = __webpack_public_path__ + "img/yemen.d4d338e1.svg";